import 'moment/locale/ja';
import { useRef, useState, useLayoutEffect } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router";
import { soloGolfCancel } from '../../const';
import common from '../../resources/js/common/common';
import { Button } from "../atoms/button";
import { ModalClose } from "../atoms/modalClose";
import './../../resources/css/soloReserve/golfSoloCancelPopup.css';

const GolfSoloCancelPopup = (props) => {
    const {
        state,
        golfSoloReserveInfo,
        onClickCloseCancelPopupWindow,
    } = props;

    const popupRef = useRef(null);
    const [errorFlg, setErrorFlg] = useState(false);

    const history = useHistory();
    const processing = useRef(false);
    useLayoutEffect(() => {
        popupRef.current.scrollTop = 0;
    }, []);

    const onClose = () => {
        onClickCloseCancelPopupWindow();
        setErrorFlg(false);
    }

    // 予約キャンセル後処理
    const afterSoloGolfCancel = (res) => {
        if (res.data.resultCode === 0) {
            //キャンセル成功画面へ遷移
            onClickCloseCancelPopupWindow();
            history.push("/reserve/golf/soloCancel");
        } else {
            setErrorFlg(true);
        }
        processing.current = false;
    }

    // 予約キャンセル
    const onClickCancel = (e) => {
        e.preventDefault();

        if (processing.current) {
            return;
        }
        processing.current = true;
        let reqObj = {
            reservationNo: golfSoloReserveInfo.reservationNo,
            soloEntryReservationNo: golfSoloReserveInfo.soloEntryReservationNo,
            familyName: golfSoloReserveInfo.familyName,
            firstName: golfSoloReserveInfo.firstName,
            familyNameKana: golfSoloReserveInfo.familyNameKana,
            firstNameKana: golfSoloReserveInfo.firstNameKana,
            applicationFamilyName: golfSoloReserveInfo.familyName,
            applicationFirstName: golfSoloReserveInfo.firstName,
            email: golfSoloReserveInfo.email,
            contactPhoneNumber: golfSoloReserveInfo.contactPhoneNumber,
            golfCourseId: golfSoloReserveInfo.golfCourseId,
            planName: golfSoloReserveInfo.planName,
            courseName: golfSoloReserveInfo.courseName,
            startTime: golfSoloReserveInfo.teetime,
            playDate: golfSoloReserveInfo.playDate
        }
        common.doPost(soloGolfCancel, reqObj, afterSoloGolfCancel);
    }

    return (
        <div ref={popupRef} className={state.golfReservationCancelPopup ? "soloCancelPopup_isShow" : "soloCancelPopup_hidden"} id="js-popup">
            <div className="soloCancelPopup_content">
                <div className="soloCancelPopup_head">
                    <ModalClose divStyle={"modalClose"} svgStyle={"modalSvg"} onClick={() => onClose()} />
                    <h4 className="soloCancelPopup_headTitle" >予約キャンセル</h4>
                </div>
                {errorFlg ?
                    <div className='soloCancelPopup_bodyArea'>
                        予約のキャンセルに失敗しました。
                    </div>
                    :
                    <div className='soloCancelPopup_bodyArea'>
                        予約のキャンセルを行いますか？
                    </div>
                }
                {errorFlg ?
                    <div className="soloCancelPopup_btnArea">
                        <Button buttonText="OK" className="soloCancelPopup_yesBtn" onClick={onClose} />
                    </div>
                    :
                    <div className="soloCancelPopup_btnArea">
                        <Button buttonText="はい" className="soloCancelPopup_yesBtn" onClick={onClickCancel} />
                        <Button buttonText="いいえ" className="soloCancelPopup_noBtn" onClick={onClose} />
                    </div>
                }
            </div>
            <div className="soloCancelPopup_blackBackground" id="js-black-bg"></div>
        </div >
    );
};


const mapStateToProps = (state) => {
    return {
        golfSoloReserveInfo: state.golfSoloReserveInfo,
    };
};

export default connect(mapStateToProps, null)(GolfSoloCancelPopup);
